import type { IconData } from '@stacksjs/iconify-core'

export const basket: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M120 304h32v128h-32zm80 0h32v128h-32zm80 0h32v128h-32zm80 0h32v128h-32z\"/><path fill=\"currentColor\" d=\"M473.681 168L394.062 16h-36.124l79.619 152H74.443l79.619-152h-36.124L38.319 168H16v111.468L58.856 496h394.261L496 281.584V168ZM464 278.416L426.883 464H85.144L48 276.332V272h416ZM464 240H48v-40h416Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default basket
